import { Component, OnInit } from '@angular/core';
import { DropzoneConfigInterface } from 'angular2-dropzone-wrapper';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-import-user-page',
  templateUrl: './import-user-page.component.html',
  styleUrls: ['./import-user-page.component.scss']
})
export class ImportUserPageComponent implements OnInit {

  constructor(private route: ActivatedRoute, private titleService: Title) { }



  userTemplateUrl: string = environment.userTemplateUrl;
  sub: any;
  orgId: number;
  config: DropzoneConfigInterface;
  error: string;

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.config = {
        dictDefaultMessage: `<div class="text">
            <p style='color: silver'>Drag completed file here</p>
            <p style='color: silver'>or</p>
            <a style="border: 1px solid black;
              border-radius: 20px;
              background: transparent;
              color: black;
              padding: 10px 20px;
              font-size: 15px;
              display: inline-block">
              <b>SELECT FILE</b>
            </a>
          </div>`,
        dictFallbackMessage: '',
        server: `${environment.organizationsUrl}/${this.orgId}/contacts/upload`,
        headers: {
          Authorization: `Bearer ${localStorage.onboardingToken}`,
        },
        maxFilesize: 2,
        acceptedFiles: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv',
        paramName: 'file',
      }
    });

    this.titleService.setTitle('Import User');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onUploadSuccess(ev: any) {
    this.error = '';
  }

  onUploadError(ev: any) {
    console.log(ev)
    this.error = 'Invalid spreadsheet format';
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/import-user-page/import-user-page.component.ts